import customFetch from "../util/config/axiosConfig";
import { ApiResponse } from "../types/responseType";
import { toast } from "sonner";
import { getErrorMessage } from "../util/functions/UniversalFunctions";
import { TimeTablePayload, TimeTableResponse } from "../types/timeTableType";

const TimeTableApis = {
  //post
  createTimeTable: async (
    payload: TimeTablePayload,
  ): Promise<ApiResponse<TimeTablePayload> | undefined> => {
    try {
      const response = await customFetch.post(
        "/api/v1/timetable/add",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      return response.data;
    } catch (error: any) {
      console.error("Error creating time table:", error);
      toast.error(getErrorMessage(error) || "Failed to create TimeTable");
    }
  },

  // GET full time table
  getEventById: async (
    classId: number,
  ): Promise<ApiResponse<TimeTableResponse> | undefined> => {
    try {
      const response = await customFetch.get(`/api/v1/timetable/full`, {
        params: { classId },
      });

      return response.data;
    } catch (error: any) {
      console.error("Error fetching time table:", error);
      toast.error(getErrorMessage(error) || "Failed to load time table");
    }
  },
};

export default TimeTableApis;
